import { Children, ReactNode } from 'react';
import { cx } from '@linaria/atomic';
import { ListRowStyles } from '../../list-row.styles';
import { ContentColumnStyleProps } from './list-row-content-column.styles';
import { ListRowSubtitle } from './list-row-subtitle';
import { ListRowTertiaryTitle } from './list-row-tertiary-title';
import { ListRowTitle } from './list-row-title';

export const ContentColumn = ({ children, ...rest }: { children: ReactNode }) => {
  const styles = ListRowStyles.ContentColumn({
    textChildren: Children.toArray(children).length as ContentColumnStyleProps['textChildren'],
  });
  const className = 'className' in rest ? (rest.className + ` content-column`).trim() : `content-column`;

  return (
    <div {...rest} className={cx(styles, className)}>
      {children}
    </div>
  );
};

ContentColumn.Title = ListRowTitle;
ContentColumn.Subtitle = ListRowSubtitle;
ContentColumn.TertiaryTitle = ListRowTertiaryTitle;
